import { useState } from "react";
import { faqs } from "@/mocks/siteContent";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8 max-w-4xl mx-auto">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-xs font-medium text-primary-600 bg-primary-50 px-3 py-1 rounded-full mb-4">
            <i className="ri-question-answer-line" aria-hidden="true"></i>
            常见问题
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
            入坑前最常被问到的几个问题
          </h2>
        </div>

        <div className="mt-8 divide-y divide-background-200/70 border-y border-background-200/70">
          {faqs.map((item, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div key={item.q}>
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : idx)}
                    aria-expanded={isOpen}
                    className="w-full flex items-center justify-between gap-4 py-5 text-left cursor-pointer"
                  >
                    <span className="font-heading text-base md:text-lg font-bold text-foreground-950">
                      {item.q}
                    </span>
                    <span className="w-7 h-7 shrink-0 flex items-center justify-center rounded-md bg-background-100 text-primary-600">
                      <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} aria-hidden="true"></i>
                    </span>
                  </button>
                </h3>
                {isOpen && (
                  <div className="pb-5 pr-10">
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}